import {
  Button,
  Card,
  Divider,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Rate,
  Select,
  Space,
  Switch,
  Tabs,
  Typography,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import type { FormProps } from "antd";
import FileUpload from "components/FileUpload";
import PageTitle from "components/PageTitle";
import { BlogVisibilityTypes } from "dtos/blog.dto";

import { ApiService } from "api/api.service";
import type { AxiosError } from "axios";
import { T_Api_Error_Res } from "api/api.types";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { TbLoader, TbUpload } from "react-icons/tb";
import DashboardLayout from "layout/DashboardLayout";
import { SocialTypes, T_Testimonials } from "dtos/testimonial.dto";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
const { Dragger } = Upload;
const { TabPane } = Tabs;

const TestimonialItem = () => {
  const { slug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedThumbnail, setSelectedThumbnail] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const addTestimonial = ApiService.testimonial.useAddTestimonial();
  const updateTestimonial = ApiService.testimonial.useUpdatetestimonial();
  const testimonialItem = ApiService.testimonial.useGetByIdOrSlug(slug);
  const mediaList = ApiService.media.useGetAllImages();
  const createMedia = ApiService.media.useCreateMedia();
  const navigate = useNavigate();
  const [testimonialForm] = Form.useForm();
  const [form] = Form.useForm();
  console.log(testimonialForm);
  const testimonialData = testimonialItem.data;
  useEffect(() => {
    testimonialForm.setFieldsValue({
      customer_name: testimonialData?.customer_name,
      company_name: testimonialData?.company_name,
      company_position: testimonialData?.company_position,
      rating: testimonialData?.rating,
      review: testimonialData?.review,
      social_links: testimonialData?.social_links,
    });
    setSelectedThumbnail(testimonialData?.image as string);
  }, [testimonialData]);

  const onFinish = async () => {
    try {
      const formData = await testimonialForm.validateFields();
      //   console.log(formData);
      const updatetestimonialData: T_Testimonials = { ...formData, image: selectedThumbnail };
      if (testimonialData && slug) {
        updateTestimonial.mutate(
          { id: testimonialData._id, body: updatetestimonialData },
          {
            onSuccess: () => {
              message.success("Testimonial updated successfully !");
              navigate(`/dashboard/testimonials?page=${searchParams.get("page")}&limit=${searchParams.get("limit")}`);
            },
            onError: () => {},
          },
        );
      } else {
        addTestimonial.mutate(updatetestimonialData, {
          onSuccess: () => {
            message.success("Testimonial created successfully");
            navigate("/dashboard/testimonials");
          },
          onError: () => {},
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleFileChange = (info: any) => {
    const { fileList } = info;
    setUploadedFiles(fileList);
  };
  const handleSaveUpload = async () => {
    const formData = new FormData();
    uploadedFiles.forEach((file: any) => {
      formData.append("file", file.originFileObj); // 'originFileObj' is the actual file
    });

    createMedia.mutate(formData, {
      onSuccess: (res: any) => {
        setSelectedThumbnail(res.data?.result?.[0]?.url || "");
        message.success("Media updated successfully");
        setIsModalVisible(false);
        form.resetFields();
        setUploadedFiles([]);
      },
      onError: () => {
        message.error("Failed to update media.");
      },
    });
  };

  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  const handleImageSelect = (url: string) => {
    setSelectedThumbnail(url);
    closeModal();
  };
  return (
    <DashboardLayout
      headerRight={
        <Button
          disabled={updateTestimonial.isPending || addTestimonial.isPending}
          type="primary"
          onClick={onFinish}
          htmlType="submit"
          icon={(updateTestimonial.isPending || addTestimonial.isPending) && <TbLoader className="animate-spin" />}
        >
          {testimonialData
            ? updateTestimonial.isPending
              ? "Updating testimonial..."
              : "Update testimonal"
            : addTestimonial.isPending
              ? "Adding category..."
              : "Add Testimonial"}
        </Button>
      }
    >
      <div className="flex m-6">
        <Card className="m-auto" style={{ width: 600, maxWidth: "100%" }}>
          <PageTitle title="Testimonial" pageTitle={[{ title: "Testimonial" }]} />
          <Form layout="vertical" form={testimonialForm}>
            <Form.Item<T_Testimonials>
              name={"customer_name"}
              label="Customer Name"
              rules={[{ required: true, message: "please fill this input" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item<T_Testimonials>
              name={"company_name"}
              label="Company Name"
              rules={[{ required: true, message: "please fill this input" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item<T_Testimonials>
              name={"company_position"}
              label="Designation"
              rules={[{ required: true, message: "please fill this input" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Rating" name={"rating"} rules={[{ required: true }]}>
              <Rate />
            </Form.Item>
            <Divider orientation="left">Social Links</Divider>

            <Form.List name={["social_links"]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Flex key={key} align="center" gap={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "type"]}
                        label="Type"
                        rules={[{ required: true, message: "Type is required" }]}
                        style={{ width: "30%" }}
                      >
                        <Select placeholder="Select social media type">
                          {Object.values(SocialTypes).map((type) => (
                            <Select.Option key={type} value={type}>
                              {type.charAt(0).toUpperCase() + type.slice(1)}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, "url"]}
                        label="URL"
                        rules={[{ required: true, message: "URL is required" }]}
                      >
                        <Input type="url" placeholder="Social link URL" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, "is_public"]} label="Public" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Flex>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                      Add Social Link
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <Form.Item<T_Testimonials>
              name={"review"}
              label="Review"
              rules={[{ required: true, message: "please fill this input" }]}
            >
              <Input.TextArea autoSize={{ minRows: 4 }} />
            </Form.Item>
            <Form.Item label="Thumbnail" name="feature_image">
              <div>
                <Button icon={<UploadOutlined />} onClick={openModal}>
                  Upload Thumbnail
                </Button>
                {selectedThumbnail && (
                  <div style={{ marginTop: 10 }}>
                    <img src={selectedThumbnail} alt="Selected Thumbnail" style={{ width: "100px", height: "auto" }} />
                  </div>
                )}
              </div>
            </Form.Item>
          </Form>
        </Card>
        {/* Modal for Image Selection */}
        <Modal
          title="Select or Upload Thumbnail"
          open={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={600}
          styles={{ body: { maxHeight: "500px", overflow: "auto" } }} // Set a max height for the modal content
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="Select" key="1">
              {/* Wrapper div for scrollable image container */}
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 2 }}>
                  {mediaList.isSuccess &&
                    mediaList.data.map((url: string, index: number) => (
                      <img
                        key={index}
                        src={url}
                        alt="Thumbnail"
                        style={{ cursor: "pointer", width: "80px", height: "100px", objectFit: "cover" }}
                        onClick={() => handleImageSelect(url)}
                      />
                    ))}
                </div>
              </div>
            </TabPane>
            <TabPane tab="Upload" key="2">
              <Form form={form} layout="vertical" initialValues={{ type: "image" }}>
                <Form.Item label="Upload Files" name="files">
                  <Dragger
                    multiple
                    fileList={uploadedFiles}
                    onChange={handleFileChange}
                    beforeUpload={() => false}
                    listType="picture"
                  >
                    <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                      <p className="ant-upload-drag-icon">
                        <TbUpload size={28} />
                      </p>
                      <p className="ant-upload-text">Click or drag files to this area to upload</p>
                      <p className="ant-upload-hint">Supports single or bulk upload.</p>
                    </div>
                  </Dragger>
                </Form.Item>
                <Button type="primary" onClick={handleSaveUpload} disabled={!uploadedFiles.length}>
                  Save Upload
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    </DashboardLayout>
  );
};

export default TestimonialItem;
